import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "form-wrapper settings-form" }
const _hoisted_3 = { class: "settings-card" }
const _hoisted_4 = {
  key: 0,
  class: "ntf-table"
}
const _hoisted_5 = {
  key: 0,
  class: "item-hint ntf-alert-hint"
}
const _hoisted_6 = {
  key: 1,
  class: "chip-editor-item-opts thl-locs ntf-locs"
}
const _hoisted_7 = ["checked", "onChange"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["onUpdate:modelValue", "disabled"]
const _hoisted_10 = { class: "chip-editor-hint ntf-phone-hint" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "ntf-warn"
}
const _hoisted_13 = {
  key: 0,
  class: "settings-card"
}
const _hoisted_14 = { class: "settings-card" }
const _hoisted_15 = { class: "item-private ntf-toggle" }
const _hoisted_16 = { class: "btn-row settings-save" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_email_recipients_editor = _resolveComponent("email-recipients-editor")!
  const _component_settings_layout = _resolveComponent("settings-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Settings"),
        _createElementVNode("div", { class: "page-bar-main" }, "Notifications")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.isAdmin)
        ? (_openBlock(), _createBlock(_component_settings_layout, {
            key: 0,
            desc: "Choose what's sent and who it goes to."
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "settings-section-h" }, "Your Alerts", -1)),
                _createElementVNode("section", _hoisted_3, [
                  (_ctx.alerts.length)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
                        _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Notify me when…"),
                            _createElementVNode("th", null, "Email"),
                            _createElementVNode("th", null, "Text")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: alert.key
                            }, [
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(alert.label), 1),
                                (alert.hint)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(alert.hint), 1))
                                  : _createCommentVNode("", true),
                                (alert.byLocation && _ctx.isOn(alert) && _ctx.$store.state.user.locations?.length > 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (loc) => {
                                        return (_openBlock(), _createElementBlock("label", {
                                          key: loc,
                                          class: "checkbox-input"
                                        }, [
                                          _createElementVNode("input", {
                                            type: "checkbox",
                                            checked: _ctx.hasLocation(alert, loc),
                                            onChange: ($event: any) => (_ctx.toggleLocation(alert, loc))
                                          }, null, 40, _hoisted_7),
                                          _createElementVNode("span", null, _toDisplayString(loc), 1)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['email', 'text'], (via) => {
                                return _createElementVNode("td", { key: via }, [
                                  _createElementVNode("label", {
                                    class: _normalizeClass(['item-private', 'ntf-switch', { 'ntf-locked': _ctx.locked(alert, via) }]),
                                    title: _ctx.locked(alert, via) ? 'At least one of email or text stays on for this one' : (via == 'email' ? 'Email' : 'Text') + ': ' + alert.label
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.mine.notifications[alert.key][via]) = $event),
                                      disabled: _ctx.locked(alert, via)
                                    }, null, 8, _hoisted_9), [
                                      [_vModelCheckbox, _ctx.mine.notifications[alert.key][via]]
                                    ]),
                                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "item-private-track" }, [
                                      _createElementVNode("span", { class: "item-private-knob" })
                                    ], -1))
                                  ], 10, _hoisted_8)
                                ])
                              }), 64))
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Phone for Text Alerts", -1)),
                  _createVNode(_component_phone_input, {
                    modelValue: _ctx.mine.phone,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mine.phone) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[7] || (_cache[7] = _createTextVNode(" Your text alerts go to this number", -1)),
                    (_ctx.mine.email)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " and email alerts to " + _toDisplayString(_ctx.mine.email), 1))
                      : _createCommentVNode("", true),
                    _cache[8] || (_cache[8] = _createTextVNode(". ", -1)),
                    (_ctx.textsOn && !_ctx.mine.phone)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Add a phone number to get your text alerts."))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "settings-section-h" }, "Company Emails & Texts", -1)),
                (_ctx.isTeamHubAdmin)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
                      _createVNode(_component_email_recipients_editor, {
                        modelValue: _ctx.formData.EmployeeEmailsNew,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.EmployeeEmailsNew) = $event)),
                        label: "Team Hub Employee Email Recipients",
                        hint: "Notified of employee updates and terminations for the locations ticked, when Send Admin Email is checked on the Edit Employee form. They don't need to be Ironbook users.",
                        "show-locations": true
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "item-private-text" }, [
                      _createElementVNode("span", { class: "item-private-title" }, "Sign-Off Reminder Texts"),
                      _createElementVNode("span", { class: "item-hint" }, "Text standard users once a day when they have new or updated processes to sign. Leave this off while your Ironbook is still being built out, so people aren't texted about every change.")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.SignReminderTexts) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.formData.SignReminderTexts]
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "item-private-track" }, [
                      _createElementVNode("span", { class: "item-private-knob" })
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-lg",
                    disabled: _ctx.disableButton,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit()))
                  }, "Save Changes", 8, _hoisted_17),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-lg btn-light",
                    disabled: _ctx.disableButton,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.load()))
                  }, "Cancel", 8, _hoisted_18)
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}